// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Xzia","buttons":"PendingPaymentAlert_buttons__1ze_t"};